import i18next from "i18next";

export const challengesPlatformOptions = [
  {
    name: "Mobile",
    value: "mobile",
  },
  {
    name: "PC",
    value: "pc",
  },
  {
    name: "Console",
    value: "console",
  },
];
export const DropdownStatusOptions = [
  {
    name: i18next.t("challenges.status.ongoing"),
    value: "ongoing",
  },
  {
    name: i18next.t("challenges.status.upcoming"),
    value: "upcoming",
  },
  {
    name: i18next.t("challenges.status.finished"),
    value: "finished",
  },
];
export const StatusOptions = [
  {
    name: "Active",
    value: "active",
  },
  {
    name: "Finished",
    value: "finished",
  },
];
